import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/AdminLayout';
import API from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminProducts() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading,  setLoading]  = useState(true);

  const load = () => {
    API.get('/products?limit=100').then(r => setProducts(r.data.products || [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const del = async (id, name) => {
    if (!window.confirm(`Delete "${name}"?`)) return;
    try { await API.delete(`/products/${id}`); toast.success('Deleted'); load(); }
    catch { toast.error('Delete failed'); }
  };

  return (
    <AdminLayout title="Products">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 20 }}>
        <button className="btn btn-primary" onClick={() => navigate('/admin/products/add')}>+ Add Product</button>
      </div>
      {loading ? <div className="spinner" /> : (
        <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', border: '1px solid var(--border)', borderRadius: 4 }}>
          <thead>
            <tr style={{ background: 'var(--cream)' }}>
              {['Product','Category','Price','Stock','Actions'].map(h => (
                <th key={h} style={{ padding: '12px 16px', fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--text-light)', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {products.map(p => (
              <tr key={p._id} style={{ borderBottom: '1px solid var(--border)' }}>
                <td style={{ padding: '12px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    {p.images?.[0]?.url
                      ? <img src={p.images[0].url} alt="" style={{ width: 40, height: 40, borderRadius: 4, objectFit: 'cover' }} />
                      : <div style={{ width: 40, height: 40, background: 'var(--cream)', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>💎</div>
                    }
                    <span style={{ fontSize: 14, fontWeight: 500 }}>{p.name}</span>
                  </div>
                </td>
                <td style={{ padding: '12px 16px', fontSize: 14, textTransform: 'capitalize' }}>{p.category}</td>
                <td style={{ padding: '12px 16px', fontSize: 14 }}>
                  <span style={{ color: 'var(--maroon)', fontWeight: 500 }}>₹{(p.discountPrice||p.price).toLocaleString()}</span>
                  {p.discountPrice && <span style={{ fontSize: 12, color: 'var(--text-light)', textDecoration: 'line-through', marginLeft: 6 }}>₹{p.price.toLocaleString()}</span>}
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <span className={`tag ${p.stock === 0 ? 'stock-out' : p.stock <= 5 ? 'stock-low' : 'stock-in-stock'}`}>
                    {p.stock === 0 ? 'Out' : p.stock <= 5 ? `Low (${p.stock})` : `${p.stock}`}
                  </span>
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => navigate(`/admin/products/edit/${p._id}`)} style={{ padding: '4px 10px', border: '1px solid var(--border)', borderRadius: 2, background: 'white', fontSize: 12, cursor: 'pointer' }}>Edit</button>
                    <button onClick={() => del(p._id, p.name)} style={{ padding: '4px 10px', border: '1px solid #FFCDD2', borderRadius: 2, background: 'white', fontSize: 12, cursor: 'pointer', color: '#C62828' }}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </AdminLayout>
  );
}
